import React from 'react';
import { InfoI, useServicesContext } from '@oneaudi/vtp-shared';
import styled from 'styled-components';
import { FocusLayerSizeV2, LayerManagerV2 } from '@volkswagen-onehub/layer-manager';
import { LayerContentHTML } from '@oneaudi/fa-one-layer';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { trackClick } from './tracking';
import { SYS_SIZE_FIXED_300 } from '@oneaudi/unified-web-common';

interface InfoButtonProps {
  url: string;
  warrantyType: string;
  pos: number;
}

const InfoButton: React.FC<InfoButtonProps> = ({ url, warrantyType, pos }) => {
  const layerManager = useServicesContext().getAdditionalService(
    'gfa:layer-manager'
  ) as LayerManagerV2;

  const trackingService = useServicesContext().getAdditionalService(
    'audi-tracking-service'
  ) as TrackingServiceV2;

  const openLayer = () => {
    layerManager?.openFocusLayer(
      () => <LayerContentHTML url={url} withFefa />,
      {},
      {
        size: FocusLayerSizeV2.A,
        userCloseable: true,
      }
    );
    trackClick(
      trackingService,
      'tooltip',
      "warranty display - click on 'info i icon'",
      '',
      '',
      'icon',
      warrantyType,
      pos.toString()
    );
  };

  return (
    <>
      <StyledIcon data-testid="infoButton" onClick={openLayer}>
        <InfoI />
      </StyledIcon>
    </>
  );
};

const StyledIcon = styled.span`
  display: inline-block;
  padding: ${SYS_SIZE_FIXED_300};
  margin: -${SYS_SIZE_FIXED_300};

  cursor: pointer;

  svg {
    vertical-align: bottom;
  }
`;

export default InfoButton;
